import { configureStore } from '@reduxjs/toolkit';
import { createInjectorsEnhancer } from 'redux-injectors';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import rootSaga from '../sagas';
import { createReducer } from './reducers';
import { socketMiddleware } from 'core/middleware/socket';
import { InjectedReducersType } from 'utils/types/injector-typings';
import devToolsEnhancer from 'remote-redux-devtools';
import { AxiosWrapper } from 'core/services/axios.wrapper';

export const history = createBrowserHistory();

export const injectedReducers: InjectedReducersType = {};
export const reducer: any = createReducer(injectedReducers);

async function onError(error) {
  console.log(error);
  await AxiosWrapper.post(`/api/error`, { type: 0, stacktrace: JSON.stringify(error), message: error.message });
}

export function configureAppStore() {
  const reduxSagaMonitorOptions = {
    onError,
  };
  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);
  const { run: runSaga } = sagaMiddleware;

  console.log(`version: ${process.env.REACT_APP_VERSION}`);

  // Create the store with saga middleware
  const middlewares:any = [sagaMiddleware, routerMiddleware(history), socketMiddleware()];

  //if (isSafari && process.env.NODE_ENV === 'development') middlewares.push(logger);

  const enhancers:any = [
    createInjectorsEnhancer({
      createReducer,
      runSaga,
    }),
  ];

  if (process.env.REACT_APP_REMOTE)
    enhancers.push(devToolsEnhancer({ realtime: true, name: 'how.io', hostname: 'localhost', port: 8000 }));

  const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }).concat(middlewares),
    devTools: { shouldHotReload: false },
    enhancers: getDefaultEnhancers => getDefaultEnhancers().concat(enhancers),
  });

  sagaMiddleware.run(rootSaga);

  return store;
}

export const store = configureAppStore();

export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
